<div (click)="loadMore.emit()" class="btn loadMore">
  Load more
</div>
